import { z } from 'zod';

export const revalidateRequestSchema = z
    .object({
        token: z.string().min(1),
        tag: z.string().min(1).optional(),
        path: z.string().min(1).optional(),
    })
    .refine(d => d.tag || d.path, { message: 'Either "tag" or "path" is required' });

export type RevalidateRequestSchema = z.infer<typeof revalidateRequestSchema>;

export const revalidateResponseSchema = z.union([
    z.object({ ok: z.literal(true) }),
    z.object({ ok: z.literal(false), error: z.string() }),
]);

export type RevalidateResponseSchema = z.infer<typeof revalidateResponseSchema>;
